import {Types} from './SettlementPayrollProcessContext'


const ModalReducer  = (state:any, action: any) =>{
  const {payload, type} = action;
  switch(type){
    case Types.CREATE_SETTLEMENT:
      return{
        ...state,
        createSettlement: payload.createSettlement
      }
    case Types.CLEAR_SETTLEMENT:
    return{
      ...state,
      _id: '',
      createSettlement: false,
      deleteModal: false,
      externoModal: false,
      incident: []
    }
    case Types.DELETE_SETTLEMENT:
      return{
        ...state,
        _id: payload._id,
        deleteModal: true
      }
      case Types.EXTERNO_SETTLEMENT:
        return{
          ...state,
          _id: payload._id,
          externoModal: true
        }
      case Types.CREATE_INCIDENT:
        
        return{
          ...state,
          incident: payload.state.incident,
        }
    default:
      return state 
  }
}

export default ModalReducer;